class ModuleActived{
    constructor(){
        const jss = document.querySelectorAll('.js-actived');

        jss.forEach((group) => {
            const groupHandles = group.querySelectorAll('.group-handle');
            const groupSections = group.querySelectorAll('.group-section');

            const sections = group.querySelectorAll('.btn-section');
            const handles = group.querySelectorAll('.btn-handle');

            
            if (groupHandles.length > 0 ){
                console.log(groupHandles)
                groupHandles.forEach((gHandles) => {
                    const handles = gHandles.querySelectorAll('.btn-handle');
                    handles.forEach(item => {
                        item.addEventListener('click', function(e){
                            e.preventDefault();

                            const valueHandle = item.dataset.handle;
        
                            if (groupSections.length > 0 ){
                                activeHandle(groupSections, valueHandle);
                            }else{
                                activeHandle(sections, valueHandle);
                            }

                            activeHandle(groupHandles, valueHandle);
                        })
                    })
                })
            }
            else{
                handles.forEach((item) => {
                    item.addEventListener('click', function(e){
                        e.preventDefault();
    
                        const valueHandle = item.dataset.handle;

                        sections.forEach((section) => {
                            const valueSection = section.dataset.handle;
                            if (valueHandle === valueSection){
                                handles.forEach(tmp => {
                                    tmp.classList.remove('actived');
                                })
                                
                                sections.forEach(tmp => {
                                    tmp.classList.remove('actived');
                                })
    
                                item.classList.add('actived');
                                section.classList.add('actived');
                            }
                        })
                    })
                })
            }
        } )

        function activeHandle(groups, value){
            if (groups.length > 0){
                groups.forEach((group) => {
                    if (group.getAttribute('data-handle')){
                        if (group.getAttribute('data-handle') === value){
                            group.classList.add('actived');
                        }else{
                            group.classList.remove('actived');
                        }
                    }else{
                        const dtHandles = group.querySelectorAll('[data-handle]');
    
                        dtHandles.forEach(handle => {
                            if (handle.dataset.handle === value){
                                handle.classList.add('actived');
                            }else{
                                handle.classList.remove('actived');
                            }
                        })
                    }
                })
            }
        }
    }
}

export default ModuleActived;